// @ts-check
// Applies the player's currently selected skin (from an account, or the local no-account
// fallback) to their own in-world character model. Uses the exact same renderer entry point
// entities.js already uses for remote players' skins, so this doesn't introduce a second
// skin-rendering code path.
import { subscribe } from 'valtio';
import { getThreeJsRendererMethods } from 'minecraft-renderer/src/three/threeJsMethods';
import { accountState, localProfile, getActiveSkinId } from './account';
import { getSkinUrlById } from './skinsRegistry';

const applyToLocalPlayer = () => {
  const bot = window.bot;
  if (!bot?.entity || !appViewer?.playerState) return;
  const skinUrl = getSkinUrlById(getActiveSkinId());
  try {
    void getThreeJsRendererMethods().updatePlayerSkin(bot.entity.id ?? '', bot.username, bot.uuid ?? bot.entity.uuid, skinUrl, null);
    appViewer.playerState.reactive.playerSkin = skinUrl;
  } catch (err) {
    console.warn('Failed to apply local player skin:', err);
  }
};

customEvents.on('gameLoaded', () => {
  applyToLocalPlayer();
});

// Re-apply live if the player changes their skin mid-session (e.g. via the account modal
// while already in a world), and when account state finishes loading after sign-in.
subscribe(accountState, () => {
  if (window.bot?.entity) applyToLocalPlayer();
});
subscribe(localProfile, () => {
  if (window.bot?.entity) applyToLocalPlayer();
});

export { applyToLocalPlayer };
